import React, { useState, createContext, useContext, useEffect } from "react";
import axios from "axios";
const SearchTermContext = createContext();

const SearchTermProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [transcript, setTranscript] = useState("");

  useEffect(() => {
    // console.log(searchTerm);
    const getTranscript = async () => {
      let videoCode;
      if (searchTerm) {
        if (searchTerm.includes("v=") && searchTerm.includes("&")) {
          videoCode = searchTerm.split("v=")[1].split("&")[0];
        }
      }
      // console.log(videoCode);
      const res = await fetch(
        `https://transcriptapi.herokuapp.com/${videoCode}`
      );
      // console.log(res);
      const data = await res.json();
      // console.log(data.eng_summary);
      setTranscript(data);
      // const res = await axios.get(`https://meet.google.com/${videoCode}`);
      // console.log(res);
    };
    getTranscript();
  }, [searchTerm]);

  return (
    <SearchTermContext.Provider
      value={{ searchTerm, setSearchTerm, transcript, setTranscript }}
    >
      {children}
    </SearchTermContext.Provider>
  );
};

export const useSearchTermContext = () => {
  return useContext(SearchTermContext);
};

export { SearchTermContext, SearchTermProvider };
